var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"integrationsClinkio field"},[_c('TextInput',{class:{ err: _vm.err },attrs:{"maxlength":"100","placeholder":_vm.$t("views.integrations.cliniko.phApiKey")},on:{"input":function($event){_vm.err = false}},model:{value:(_vm.apiKey),callback:function ($$v) {_vm.apiKey=$$v},expression:"apiKey"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }